import Reveal from "./Reveal";
import { useGo } from "./Nav";

const CLIENTS = [
  "Homeowners & Villas",
  "Architects",
  "Interior Designers",
  "Hospitality — Cafés & Lounges",
  "Commercial Spaces",
];

export default function Clientele() {
  const go = useGo();
  return (
    <section data-testid="clientele-section" className="bg-oxblood py-28 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-brass-soft text-xs tracking-[0.45em] uppercase mb-6">Clientele</p>
          <h2 className="font-display text-ivory text-4xl md:text-6xl leading-tight max-w-3xl">
            A clientele that expects <em className="text-brass-soft font-light">the exceptional.</em>
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24">
          {CLIENTS.map((c, i) => (
            <Reveal key={c} delay={i * 0.05}>
              <button
                data-testid={`clientele-row-${i}`}
                onClick={() => go("book")}
                className="group w-full flex items-center justify-between border-t border-ivory/15 py-8 md:py-10 text-left"
              >
                <span className="font-display text-ivory/85 text-2xl md:text-5xl font-light group-hover:text-brass-soft group-hover:pl-4 md:group-hover:pl-8 transition-all duration-500">
                  {c}
                </span>
                <span className="text-brass text-2xl md:text-3xl opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
                  →
                </span>
              </button>
            </Reveal>
          ))}
          <div className="border-t border-ivory/15" />
        </div>
      </div>
    </section>
  );
}
